import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ISbStoryData } from '@storyblok/js';
import { map } from 'rxjs';
import { PICFLOW_STORYBLOK } from '../../../picflow-storyblok';
import { PricingService } from '../../../services/pricing.service';
import { ProductFeatureTooltipComponent } from '../../../shared/components/product-feature-tooltip/product-feature-tooltip.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { StoryblokRichTextPipe } from '../../../storyblok/storyblok-rich-text.pipe';
import { Product } from '../../../types/product.type';

@Component({
  selector: 'app-checkout-sidebar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgComponent, DatePipe, StoryblokRichTextPipe, ProductFeatureTooltipComponent],
  templateUrl: './checkout-sidebar.component.html',
  styleUrl: './checkout-sidebar.component.scss',
})
export class CheckoutSidebarComponent {
  private pricingService = inject(PricingService);
  private storyblokService = inject(PICFLOW_STORYBLOK);
  product = input.required<Product>();
  startTrialMode = input.required<boolean>();
  trialLengthDays = signal(this.pricingService.getTrialLengthDays());
  trialEndDate = computed(() => new Date(Date.now() + this.trialLengthDays() * 24 * 60 * 60 * 1000));
  allPricingBoxContent = toSignal(
    this.storyblokService.getStories({ content_type: 'PricingBox' }).pipe(map(resp => resp.stories))
  );
  pricingBoxContent = computed(() => {
    const allPricingBoxContent = this.allPricingBoxContent();
    const product = this.product();
    if (!allPricingBoxContent || !product) return;

    return allPricingBoxContent.find((data: ISbStoryData) => data.content.product === product.storyblokLinkId);
  });
}
